import { useState, useEffect } from 'react';
import { FOCUS_DELAY } from '../../lib/constants/auth';

export const useEmailInputFocus = (showCodeInput: boolean) => {
  const [inputElement, setInputElement] = useState<HTMLInputElement | null>(null);

  useEffect(() => {
    if (!showCodeInput && inputElement) {
      // Short timeout to ensure DOM is ready, especially on mobile
      setTimeout(() => {
        inputElement?.focus();
      }, FOCUS_DELAY);
    }
  }, [showCodeInput, inputElement]);

  return { inputElement, setInputElement };
};
